<template>
  <div>
    <a-row>
      <g-master name="forms"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :modalFieldsSetup="master.modalFieldsSetup"
                :parentData="ParentData"
                @action="masterAction"
                ref="master"
      >
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <g-dropdown :label="$t('Compañía')"
                          :formItemConfig="fiOptions"
                          :selectConfig="{mode:'multiple'}"
                          endpoint="company"
                          :decorator="['id_company', { rules: [{ required: false }] }]"
              >
              </g-dropdown>
            </a-col>
          </a-row>
        </template>
      </g-master>
    </a-row>
    <a-row>
    </a-row>
  </div>
</template>

<script>
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import HttpUtil from '@/util/HttpUtil'

  export default {
    data () {
      return {
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'user_company',
          tableSetup: {
            actions: {
              actions: [
                {
                  name: 'eliminar',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'delete'}
                }
              ]
            },
            tableConfig: {
              rowKey: 'id_user_company'
            },
            columns: [
              {title: 'Compañía', dataIndex: 'company_desc', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'id_company'}
          ]
        }
      }
    },
    props: ['name'],
    computed: {
      ParentData () {
        return {
          user_name: this.name
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'eliminar':
            console.log(action.record)
            this.$confirm({
              title: 'Confirmación',
              content: '¿Está seguro que desea eliminar el registro?',
              onOk: () => {
                return new Promise((resolve, reject) => {
                  this.httpClient.getInstance().delete('user_company/-1', {
                    data: {user_name: action.record.user_name, id_company: action.record.id_company}
                  })
                    .then(() => {
                      this.$refs.master.$refs.datatable.loadData()
                      resolve()
                    })
                    .catch((error) => {
                      Mensajes.error('Error', 'No fue posible eliminar el registro')
                      reject(error)
                    })
                })
              },
              onCancel () { }
            })
            break
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/User/UserCompany.vue